import script from "./badge.vue?vue&type=script&setup=true&lang=js"
export * from "./badge.vue?vue&type=script&setup=true&lang=js"

import "./badge.vue?vue&type=style&index=0&id=ee523eea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee523eea"]])

export default __exports__